<div *ngIf="showLine" class="{{siteId}} horizontal-separator"></div>
<div id="footerWrapper"
    class="syndicated-footer-wrapper"
    [@footerState]="stateName"
    (@footerState.done)="footerStateDone($event)">
    <script-loader [src]="syndicatedFooterUrl"></script-loader>
</div>
